'use client';
import React from 'react';
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend,
} from 'recharts';
import { attendanceChartData } from '@/lib/mockData';

const CustomTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-card border border-border rounded-lg shadow-lg p-3 text-sm">
      <p className="font-600 text-foreground mb-2">{label}</p>
      {payload.map((p: any) => (
        <div key={`tt-${p.dataKey}`} className="flex items-center gap-2">
          <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: p.color }} />
          <span className="text-muted-foreground capitalize">{p.dataKey}:</span>
          <span className="font-600 text-foreground">{p.value}</span>
        </div>
      ))}
    </div>
  );
};

export default function AttendanceTrendChart() {
  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h2 className="text-base font-600 text-foreground">Daily Attendance — Past 7 Days</h2>
          <p className="text-xs text-muted-foreground mt-0.5">Present, absent, and late across all active sites</p>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={220}>
        <AreaChart data={attendanceChartData} margin={{ top: 5, right: 10, left: -10, bottom: 0 }}>
          <defs>
            <linearGradient id="gradPresent" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="var(--status-active)" stopOpacity={0.25} />
              <stop offset="95%" stopColor="var(--status-active)" stopOpacity={0.02} />
            </linearGradient>
            <linearGradient id="gradAbsent" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="var(--status-fired)" stopOpacity={0.2} />
              <stop offset="95%" stopColor="var(--status-fired)" stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
          <XAxis dataKey="date" tick={{ fontSize: 12, fill: 'var(--muted-foreground)' }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 12, fill: 'var(--muted-foreground)' }} axisLine={false} tickLine={false} />
          <Tooltip content={<CustomTooltip />} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Area type="monotone" dataKey="present" stroke="var(--status-active)" strokeWidth={2} fill="url(#gradPresent)" name="Present" />
          <Area type="monotone" dataKey="absent" stroke="var(--status-fired)" strokeWidth={2} fill="url(#gradAbsent)" name="Absent" />
          <Area type="monotone" dataKey="late" stroke="var(--status-suspended)" strokeWidth={2} fill="none" strokeDasharray="4 2" name="Late" />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}